<template>
  <div class="poll-results panel-settings">
    <!-- QR Code -->
    <p class="tb-label">QR Code</p>
    <div class="tb-checkbox" data-entity="producer-editor-toggleQRCode">
      <input type="checkbox" id="showQrCode" v-model="showQrCode">
      <label class="checkbox" for="showQrCode">Show</label>
    </div>

    <template v-if="showQrCode">
      <qr-code-url
        :url.sync="qrCodeUrl"
        :short-url.sync="qrCodeShortUrl"
        :product-info.sync="qrProductInfo"
        :item="editing"
        :element="panel"
        :entity-id="panel._id"
      />

      <div class="tb-form-group margin-top-md">
        <label class="tb-label">Background Color</label>

        <colorpicker
          :color="panelFields.qrCodeBackgroundColor"
          data-entity="producer-editor-toggleQRCodeBackgroundColorPicker"
          @change="setField('qrCodeBackgroundColor', $event)"
        />
      </div>

      <div class="tb-form-group">
        <label class="tb-label">Dot Color</label>

        <colorpicker
          :color="panelFields.qrCodeDotColor"
          data-entity="producer-editor-toggleQRCodeDotColorPicker"
          @change="setField('qrCodeDotColor', $event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import HotKeysComponent from '../../hotkeys/HotKeys.vue';
import QrCodeUrl from '../../../shared/QrCodeUrl.vue';

import editingMixins from '../../../../mixins/editing-mixins';

export default {
  mixins: [editingMixins],

  props: ['panel', 'editing', 'item', 'production_context'],

  components: {
    'hot-keys': HotKeysComponent,
    QrCodeUrl,
  },

  data() {
    return {
      qrDefaults: {
        // mirrors tgb-smart-panels defaults to make this backwards compatible with
        // results panels created before the QR code was added
        qrCodeBackgroundColor: 'rgba(0, 0, 0, 0)',
        qrCodeDotColor: '#ffffff',
        qrCodeUrl: 'https://tagboard.com',
        qrCodeShortUrl: '',
      },
    };
  },

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },

  computed: {
    showQrCode: {
      get() {
        return this.panelFields.showQrCode;
      },

      set(v) {
        const fields = {
          ...this.item.settings,
          ...this.item.fields,
        };

        if (!('showQrCode' in fields)) {
          // Set defaults if the item doesn't have them (for backwards compatibility)
          this.setQrDefaults();
        }

        this.setField('showQrCode', v);
        this.$set(this.item.settings, 'showQrCode', v);
      },
    },

    qrCodeUrl: {
      get() {
        return this.panelFields.qrCodeUrl;
      },

      set(v) {
        this.setField('qrCodeUrl', v);
      },
    },

    qrCodeShortUrl: {
      get() {
        return this.panelFields.qrCodeShortUrl ?? '';
      },
      set(v) {
        this.setField('qrCodeShortUrl', v);
      },
    },

    qrProductInfo: {
      get() {
        return this.panelFields.qrProductInfo ?? {};
      },
      set(v) {
        this.setField('qrProductInfo', v);
      },
    },
  },

  methods: {
    setQrDefaults() {
      this.setField('qrCodeBackgroundColor', this.qrDefaults.qrCodeBackgroundColor);
      this.setField('qrCodeDotColor', this.qrDefaults.qrCodeDotColor);
      this.setField('qrCodeUrl', this.qrDefaults.qrCodeUrl);
      this.setField('qrCodeShortUrl', this.qrDefaults.qrCodeShortUrl);
    },
  },
};
</script>
